"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _heroSlide = require("../../hero-slide.styled");

var _buttons = _interopRequireDefault(require("../buttons"));

var _textImage = _interopRequireDefault(require("../text-image"));

var _heroSlideD = require("./hero-slide-d.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HeroSlideD = function HeroSlideD(_ref) {
  var line1 = _ref.lineOneText,
      line2 = _ref.lineTwoText,
      line3 = _ref.lineThreeText,
      line4 = _ref.lineFourText,
      line5 = _ref.lineFiveText,
      type = _ref.textType,
      images = _ref.textAsImages,
      buttons = _ref.buttons,
      position = _ref.contentPosition,
      bg = _ref.textBackgroundColor,
      bgStyles = _ref.bgStyles;
  var isBgColorBlock = bg !== 'transparent';
  return /*#__PURE__*/_react.default.createElement(_heroSlideD.Wrap, {
    bgStyles: isBgColorBlock ? bgStyles : '',
    position: position
  }, /*#__PURE__*/_react.default.createElement(_heroSlideD.HeroSlideBlock, _extends({
    position: position
  }, {
    bg: bg
  }), /*#__PURE__*/_react.default.createElement(_heroSlideD.Content, null, type === 'type_text' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, line1 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line1, {
    as: "h4"
  }, line1), line2 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line2, {
    as: "h2"
  }, line2), line3 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line3, {
    as: "h2"
  }, line3), !!(line4 || line5) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: 10
  }, line4 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line4, {
    as: "h4"
  }, line4), line5 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line5, {
    as: "h4"
  }, line5))) : /*#__PURE__*/_react.default.createElement(_textImage.default, {
    images: images
  })), /*#__PURE__*/_react.default.createElement(_buttons.default, {
    color: bg,
    buttons: buttons
  })));
};

var _default = HeroSlideD;
exports.default = _default;